import { z } from "zod";

export const ResourceTypes = {
  FILE: "File",
  ARTICLE: "Article",
  PARTNER_PAGE: "Partner Page",
  SERIES: "Series",
  VIDEO: "Video",
  PODCAST: "Podcast",
  NEWS: "News",
} as const;

export const resourceFormSchema = z.object({
  title: z
    .string()
    .min(1, "Title is required")
    .max(255, "Title must be 255 characters or fewer"),
  slug: z.string().min(1, "Slug is required"),
  searchDescription: z.string().min(1, "Search description is required"),
  type: z.coerce.number().nullable().optional(),
  content_url: z.string().optional(),
  fileUuid: z.string().nullable().optional(), // For File type resources
  thumbnailFileUuid: z.string().nullable().optional(),
  publish_start_date: z.coerce.date().nullable().optional(),
  publish_end_date: z.coerce.date().nullable().optional(),
  is_published: z.boolean().optional(),
  is_featured: z.boolean().optional(),
  requiresEaglesAccess: z.boolean().optional(),
  requiresLATAAccess: z.boolean().optional(),
  hiddenFromLATASubscribers: z.boolean().optional(),
  tags: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional(),
  categories: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional(),
  tradeIds: z.array(z.string()).optional(),
  roleIds: z.array(z.string()).optional(),

  stage: z.object({ id: z.string(), name: z.string() }).nullable(),

  processWheel: z.object({ id: z.string(), name: z.string() }).nullable(),

  contentBlocks: z
    .array(
      z.object({
        id: z.string().optional(),
        type: z.enum([
          "text",
          "image",
          "file",
          "link",
          "video",
          "audio",
          "resource_reference",
          "faq",
          "columns",
          "quote",
          "heading",
        ]),
        content: z.string(),
        order_number: z.number().optional(),
        metadata: z.record(z.any()).optional(),
        fileUuid: z.string().nullable().optional(),
        title: z.string().optional(),
        shortDescription: z.string().optional(),
        resourceReferenceIds: z.array(z.number()).optional(),
        tradeIds: z.array(z.number()).optional(),
      }),
    )
    .optional(),

  relatedResources: z
    .array(z.object({ id: z.number(), name: z.string() }))
    .optional(),

  seriesEntries: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        sortOrder: z.number().optional(),
      }),
    )
    .optional(), // For Series type resources
});

export type ResourceFormData = z.infer<typeof resourceFormSchema>;
